import { useMount } from 'react-use';
import { routingService } from 'services/routing';
import { useOpenProfileEditPopup } from 'shared/components';

export const useProfilePageData = () => {
    const { handleOpenPopup } = useOpenProfileEditPopup();

    useMount(() => {
        handleOpenPopup();

        routingService.replaceToDefaultPath();
    });
};
